import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["message", "rebrandMessage"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useHasBusinessUnitsRebrand } from '../hooks/useHasBusinessUnitsRebrand';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { jsx as _jsx } from "react/jsx-runtime";
export const BusinessUnitsRebrandMessage = _ref => {
  let {
      message,
      rebrandMessage
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const hasBusinessUnitsRebrand = useHasBusinessUnitsRebrand();

  // If ungated for business units rebrand, check if the rebrand message is a valid i18n key if not revert to the original message.
  const newMessage = hasBusinessUnitsRebrand ? isValidI18nKey(rebrandMessage) ? rebrandMessage : message : message;
  return /*#__PURE__*/_jsx(FormattedMessage, Object.assign({
    message: newMessage
  }, rest));
};